// range(start, stop, step) util
export const range = (start, stop, step = 1) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)

// Calculate time to read a post
// const countWords = str => str.trim().split(/\s+/).length
// export const getTimeToRead = str => Math.ceil(countWords(str) / 200)

// Convert to local date string e.g. November 16, 2021
// export const getDateStr = date => {
//   const options = { year: "numeric", month: "long", day: "numeric" }
//   return new Date(date).toLocaleDateString("en-US", options)
// }

// Encode form values to x-www-form-urlencoded format
// export const encodeToUrl = data =>
//   Object.keys(data)
//     .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
//     .join("&")

// Encode form values to FormData object
export const encodeToFormData = (dataForm, isMultiPart = false) => {
  // console.log(dataForm);
  const formData = new FormData()
  const data = {}
  for (const [key, value] of Object.entries(dataForm)) {
    if (isMultiPart) {
      if (value.type) {
        // console.log(value, value.name)
        // files.forEach((file) => {
        formData.append(`files.${key}`, value, value?.name)
        // });
      } else {
        // formData.append(key, value);
        data[key] = value
      }
    } else {
      formData.append(key, value)
    }
  }
  isMultiPart && formData.append("data", JSON.stringify(data))
  // console.log("Formssss", [...formData])

  return formData
}

export const stringTruncate = function (str, length) {
  const dots = str?.length > length ? "..." : ""
  return str?.substring(0, length) + dots
}

function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var s = document.createElement("script")
    s.defer = true
    s.async = true
    s.src = src
    s.onload = resolve
    s.onerror = reject
    document.head.appendChild(s)
  })
}

export const openCalendlyPopup = async () => {
  const link = document.createElement("link")
  link.rel = "stylesheet"
  link.href = "https://assets.calendly.com/assets/external/widget.css"
  document.head.appendChild(link)

  await loadScript("https://assets.calendly.com/assets/external/widget.js")

  // Now that the Calendly script is loaded, access Calendly from the global scope
  Calendly.initPopupWidget({
    url: "https://calendly.com/hassaan-invozone/30min",
  })
}

export const dateDiffInDays = (date1, date2) => {
  const diffTime = Math.abs(date2 - date1)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  // return new Date(date1).getTime() > new Date(date2).getTime()?  diffDays : -diffDays
  return diffDays
}

// Test if the given string is a validated email address
export const isEmail = str => {
  if (!str || typeof str !== "string") return false

  const trimmedStr = str.trim()
  const pattern =
    /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,63}$/

  return pattern.test(trimmedStr)
}

export const stripHtml = str => {
  if (typeof str !== "string") return str
  return str
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim()
}

export const isValidHttpUrl = string => {
  let url
  try {
    url = new URL(string)
  } catch (_) {
    return false
  }
  return url.protocol === "http:" || url.protocol === "https:"
}

/**
 * Same base as Strapi form URLs (`GATSBY_STRAPI_API_URL`). Falls back to prod CMS if unset.
 * Keeps `verifyEmailExists` / geo calls aligned with `contactusforms` during local dev.
 */
export const strapiSiteUrl = (
  typeof process.env.GATSBY_STRAPI_API_URL === "string" &&
  process.env.GATSBY_STRAPI_API_URL.trim()
    ? process.env.GATSBY_STRAPI_API_URL.trim()
    : "https://cms.invozone.com"
).replace(/\/$/, "")

const VERIFY_EMAIL_API =
  (typeof process.env.GATSBY_VERIFY_EMAIL_API_URL === "string" &&
  process.env.GATSBY_VERIFY_EMAIL_API_URL.trim()
    ? process.env.GATSBY_VERIFY_EMAIL_API_URL.trim()
    : `${strapiSiteUrl}/api/verify-email-exists`)

const ELV_REJECT = new Set([
  "email_disabled",
  "dead_server",
  "invalid_mx",
  "disposable",
  "spamtrap",
  "invalid_syntax",
])

/** No credit charged; do not block the form. */
const ELV_INCONCLUSIVE = new Set([
  "smtp_protocol",
  "antispam_system",
  "unknown",
])

export const verifyEmailExists = async email => {
  if (!email || !isEmail(email)) {
    return { valid: false, exists: false, message: "Invalid email" }
  }

  try {
    const sep = VERIFY_EMAIL_API.includes("?") ? "&" : "?"
    const response = await fetch(
      `${VERIFY_EMAIL_API}${sep}email=${encodeURIComponent(email.trim())}`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
        cache: "no-store",
      }
    )

    if (response.status === 400) {
      return { valid: false, exists: false, message: "Invalid email" }
    }

    if (!response.ok) return { valid: true, exists: null, message: null }

    let payload
    try {
      payload = await response.json()
    } catch {
      return { valid: true, exists: null, message: null }
    }

    if (payload?.configured === false) {
      return { valid: true, exists: null, message: null }
    }

    if (!payload?.upstreamOk) return { valid: true, exists: null, message: null }

    const text = typeof payload.text === "string" ? payload.text : ""
    let data = {}
    if (text) {
      try {
        data = JSON.parse(text)
      } catch {
        // Legacy/plain responses return a single status token (e.g. "ok", "spamtrap").
        const plain = text.trim().toLowerCase()
        if (plain) data = { status: plain }
      }
    }
    const status = String(data.status || data.result || "").toLowerCase()

    if (data.disposable === true) {
      return { valid: true, exists: false, message: "Invalid email" }
    }

    if (status === "ok" || status === "valid") {
      return { valid: true, exists: true, message: null }
    }

    if (status === "ok_for_all" || data.accept_all === true) {
      return { valid: true, exists: false, message: "Invalid email" }
    }

    if (ELV_REJECT.has(status)) {
      return { valid: true, exists: false, message: "Invalid email" }
    }

    if (ELV_INCONCLUSIVE.has(status)) {
      return { valid: true, exists: null, message: null }
    }

    return { valid: true, exists: null, message: null }
  } catch (error) {
    return { valid: isEmail(email), exists: null, message: null }
  }
}

const USER_COUNTRY_CACHE_KEY = "invo_user_country"
const USER_LOCATION_CACHE_KEY = "invo_user_location"
const GEO_API = `${strapiSiteUrl}/api/getUserLocation`

export const getUserCountry = () => {
  if (typeof window === "undefined") return Promise.resolve("")
  const cached = sessionStorage.getItem(USER_COUNTRY_CACHE_KEY)
  if (cached) return Promise.resolve(cached)

  return fetch(GEO_API, {
    method: "GET",
  })
    .then(res => res.json())
    .then(data => {
      if (!data?.success) return ""
      const code = (data?.country_code || "").toLowerCase()
      if (code) {
        sessionStorage.setItem(USER_COUNTRY_CACHE_KEY, code)
        sessionStorage.setItem(
          USER_LOCATION_CACHE_KEY,
          JSON.stringify({
            country: data.country,
            country_code: data.country_code,
            calling_code: data.calling_code,
            region: data.region,
            city: data.city,
          })
        )
      }
      return code
    })
    .catch(() => "")
}

export const getUserLocation = () => {
  if (typeof window === "undefined") return Promise.resolve(null)
  const cached = sessionStorage.getItem(USER_LOCATION_CACHE_KEY)
  if (cached) {
    try {
      return Promise.resolve(JSON.parse(cached))
    } catch {
      return getUserCountry().then(() => {
        const c = sessionStorage.getItem(USER_LOCATION_CACHE_KEY)
        return c ? JSON.parse(c) : null
      })
    }
  }
  return getUserCountry().then(() => {
    const c = sessionStorage.getItem(USER_LOCATION_CACHE_KEY)
    return c ? JSON.parse(c) : null
  })
}

export const BLOCKED_MODAL_COUNTRY_CODES = ["pk", "in"]

const isBlockedModalCountryCode = code =>
  BLOCKED_MODAL_COUNTRY_CODES.includes(String(code || "").toLowerCase())

const BLOCKED_REGION_LOOKUP_TIMEOUT_MS = 10000

const getCachedBlockedModalCountry = () => {
  if (typeof window === "undefined") return false
  const cached = sessionStorage.getItem(USER_COUNTRY_CACHE_KEY)
  return isBlockedModalCountryCode(cached)
}

const cacheCountryCode = code => {
  const normalized = String(code || "").toLowerCase()
  if (normalized) {
    sessionStorage.setItem(USER_COUNTRY_CACHE_KEY, normalized)
  }
  return normalized
}

/** Sync check from session cache (use before async IP lookup completes). */
export const isBlockedModalRegionCached = () => getCachedBlockedModalCountry()

export const GEO_MODAL_REGION_ATTR = "data-geo-modal"

export const setGeoModalRegionState = state => {
  if (typeof document === "undefined") return
  document.documentElement.setAttribute(GEO_MODAL_REGION_ATTR, state)
}

/** Runs before React paint — reads sessionStorage and sets html attribute. */
export const syncGeoModalRegionFromCache = () => {
  if (typeof window === "undefined") return "pending"

  const cachedCode = sessionStorage.getItem(USER_COUNTRY_CACHE_KEY)
  if (!cachedCode) {
    setGeoModalRegionState("pending")
    return "pending"
  }

  const state = isBlockedModalCountryCode(cachedCode) ? "blocked" : "allowed"
  setGeoModalRegionState(state)
  return state
}

/** Pakistan / India IP — uses session cache first, then live lookups. */
const resolveBlockedModalRegionByIp = async () => {
  if (typeof window === "undefined") return false

  const cachedCode = sessionStorage.getItem(USER_COUNTRY_CACHE_KEY)
  if (cachedCode) {
    return isBlockedModalCountryCode(cachedCode)
  }

  try {
    const res = await fetch(GEO_API, { method: "GET", cache: "no-store" })
    const data = await res.json()
    if (data?.success) {
      const code = cacheCountryCode(data?.country_code)
      if (isBlockedModalCountryCode(code)) return true
    }
  } catch {
    // try next provider
  }

  try {
    const res = await fetch("https://get.geojs.io/v1/ip/country.json", {
      cache: "no-store",
    })
    const data = await res.json()
    if (data?.country) {
      const code = cacheCountryCode(data.country)
      if (isBlockedModalCountryCode(code)) return true
    }
  } catch {
    // try next provider
  }

  try {
    const res = await fetch("https://ipwho.is/", { cache: "no-store" })
    const data = await res.json()
    if (data?.country_code) {
      const code = cacheCountryCode(data.country_code)
      if (isBlockedModalCountryCode(code)) return true
    }
  } catch {
    // ignore
  }

  return getCachedBlockedModalCountry()
}

export const isUserInBlockedModalRegion = () =>
  Promise.race([
    resolveBlockedModalRegionByIp(),
    new Promise(resolve => {
      setTimeout(() => resolve(getCachedBlockedModalCountry()), BLOCKED_REGION_LOOKUP_TIMEOUT_MS)
    }),
  ])
    .then(blocked => {
      setGeoModalRegionState(blocked ? "blocked" : "allowed")
      return blocked
    })
    .catch(() => {
      const blocked = getCachedBlockedModalCountry()
      setGeoModalRegionState(blocked ? "blocked" : "allowed")
      return blocked
    })

// Recaptcha Google keys
export const SITE_KEY = "6LctCrcqAAAAAPZIuGByBSpZYw-GK7S2Rc8zOsg_"
// export const SECTION_KEY = "6LeqtoQfAAAAAIXJhMS7_6ScQDu0EppO59VdUBGW"
